import { Button, Stack, Typography } from "@mui/material";

type TProps = {
    handleRedirect: () => void;
};

export default function StepThree({ handleRedirect }: TProps) {
    const textStyle = {
        textAlign: "center",
        width: { xs: "75%", md: "23%" },
        lineHeight: 2,
    };

    return (
        <Stack alignItems="center" spacing={6}>
            <Typography sx={textStyle} textAlign="center">
                تبریک! شما در پرشین‌سازه ثبت نام کردید. برای دریافت جایزه خود
                وارد پنل شوید.
            </Typography>

            <Button
                sx={{ width: { xs: "75%", md: "23%" } }}
                size="large"
                variant="contained"
                color="secondary"
                onClick={handleRedirect}
            >
                ورود به پنل پرشین سازه و دریافت جایزه
            </Button>
        </Stack>
    );
}
